import { render } from "./PopComponent.vue?vue&type=template&id=b817c008&scoped=true"
import script from "./PopComponent.vue?vue&type=script&lang=js"
export * from "./PopComponent.vue?vue&type=script&lang=js"

import "./PopComponent.vue?vue&type=style&index=0&id=b817c008&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b817c008"]])

export default __exports__